import axios from "axios";
export const PRODUCTS_URL = "https://app.willianbuqui.dev";
// export const PRODUCTS_URL = "http://localhost:9000";


export function enviarEmail(data) {
    return axios.post(`${PRODUCTS_URL}/email`, data);
};

